import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import { MdVolumeUp, MdVolumeOff } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import { HiUser } from "react-icons/hi";
import { MdListAlt } from "react-icons/md";
import { HiOutlineLogout } from "react-icons/hi";
import "./Navbar.css";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const location = useLocation();

  const toggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    if (location.pathname === "/videos" && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  }, [location.pathname, isPlaying]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
      <audio
        ref={audioRef}
        loop
        muted={false}
        controls={false}
        style={{ display: "none" }}
      >
        <source
          src="https://games.learntu.org/uploads/contents/1733431885_stranger-things-124008.mp3"
          type="audio/mp3"
        />
        Your browser does not support the audio element.
      </audio>
      <nav className="navbar">
        <ul className="navbar-list">
          <li>
            <Link to={user ? "/" : "/login"}>
              <BiHomeAlt className="nav-icon" title="Home" />
            </Link>
          </li>
          <li>
            <Link to={user ? "/result" : "/login"}>
              <MdListAlt className="nav-icon" title="My Result" />
            </Link>
          </li>
          <li>
            <button
              className="sound-toggle-button"
              onClick={toggleAudio}
              aria-label={isPlaying ? "Mute Music" : "Unmute Music"}
            >
              {isPlaying ? <MdVolumeUp /> : <MdVolumeOff />}
            </button>
          </li>
          <li>
            <Link to={"/login"} onClick={handleLogout}>
              <HiOutlineLogout className="nav-icon" title="Logout" />
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
